// src/components/Instruction.jsx
import React from 'react';
import { useTranslation } from '../context/AppContext';
import { motion } from 'framer-motion';

export default function Instruction() {
  const { t } = useTranslation();

  const steps = [
    { title: t.step1, desc: t.step1Desc },
    { title: t.step2, desc: t.step2Desc },
    { title: t.step3, desc: t.step3Desc },
    { title: t.step4, desc: t.step4Desc },
    { title: t.step5, desc: t.step5Desc },
    { title: t.step6, desc: t.step6Desc },
  ];

  return (
    <section id="instruction" className="py-16 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">{t.instruction}</h2>
        <div className="space-y-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex items-start gap-4"
            >
              <div className="flex-shrink-0 w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg">
                {index + 1}
              </div>
              <div>
                <h3 className="text-xl font-semibold">{step.title}</h3>
                <div
  className="text-gray-600 mt-1 leading-relaxed"
  dangerouslySetInnerHTML={{ __html: step.desc }}
/>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}